module.exports = __webpack_public_path__ + "img/cl2.791fe006.png";